import { useQuery } from '@tanstack/react-query'
import { gebruiktMockApi, http } from './api'
import { mockVak, mockVakmatrix } from './__fixtures__/beheer-fixtures'
import { vertraag } from './__fixtures__/vertraag'
import type { Vak, Vakmatrix } from './vak-types'

export interface VakApi {
  matrix(semesterId: string): Promise<Vakmatrix>
  get(semesterId: string, naam: string): Promise<Vak>
}

class RealVakApi implements VakApi {
  matrix(semesterId: string): Promise<Vakmatrix> {
    return http.get<Vakmatrix>('/api/vakken', { semester: semesterId })
  }
  get(semesterId: string, naam: string): Promise<Vak> {
    return http.get<Vak>(`/api/vakken/${encodeURIComponent(naam)}`, { semester: semesterId })
  }
}

class MockVakApi implements VakApi {
  matrix(semesterId: string): Promise<Vakmatrix> {
    return vertraag(mockVakmatrix(semesterId))
  }
  get(semesterId: string, naam: string): Promise<Vak> {
    return vertraag(mockVak(semesterId, naam))
  }
}

export const vakApi: VakApi = gebruiktMockApi ? new MockVakApi() : new RealVakApi()

export const vakKeys = {
  alle: ['vakken'] as const,
  matrix: (semesterId: string) => ['vakken', semesterId, 'matrix'] as const,
  detail: (semesterId: string, naam: string) => ['vakken', semesterId, 'detail', naam] as const,
}

export function useVakmatrix(semesterId: string) {
  return useQuery({
    queryKey: vakKeys.matrix(semesterId),
    queryFn: () => vakApi.matrix(semesterId),
    enabled: semesterId !== '',
  })
}

export function useVak(semesterId: string, naam: string) {
  return useQuery({
    queryKey: vakKeys.detail(semesterId, naam),
    queryFn: () => vakApi.get(semesterId, naam),
    enabled: semesterId !== '' && naam !== '',
  })
}
